import { createAsyncThunk } from '@reduxjs/toolkit'

import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { callErrorMsg } from 'helpers/errorMsg'

import {
  getApprovalEngineStatsAPI,
  getApprovalEngineListAPI,
  getApprovalWorkflowComponentsAPI,
  getApprovalWorkflowListAPI,
} from 'features/ApprovalEngine/services/ApprovalEngineList'
import {
  setIsLoading,
  setIsLoadingList,
  setStats,
  setList,
  setPagination,
  setComponents,
  setWorkflows,
} from 'features/ApprovalEngine/redux/approvalEngineList/slice'

const SLICE_NAME = 'approvalEngineList'

export const fetchApprovalEngineStats = createAsyncThunk(
  `${SLICE_NAME}/getApprovalEngineStats`,
  async (_, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const res = await getApprovalEngineStatsAPI()

      dispatch(setStats(res.data.data))
      dispatch(setIsLoading(false))

      return true
    } catch (error) {
      callErrorMsg(error)
      dispatch(setIsLoading(false))
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchApprovalWorkflowComponents = createAsyncThunk(
  `${SLICE_NAME}/getApprovalWorkflowComponents`,
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await getApprovalWorkflowComponentsAPI()
      dispatch(setComponents(res.data.data?.approval_status?.values || []))
      return true
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchApprovalWorkflowList = createAsyncThunk(
  `${SLICE_NAME}/getApprovalWorkflowList`,
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await getApprovalWorkflowListAPI()
      dispatch(setWorkflows(res.data.data || []))
      return true
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const getApprovalEngineList = createAsyncThunk(
  `${SLICE_NAME}/getApprovalEngineList`,
  async (_, { rejectWithValue, getState, dispatch }) => {
    const {
      approvalEngineList: { params },
    } = getState() as StoreStateType

    dispatch(setIsLoadingList(true))
    try {
      const res = await getApprovalEngineListAPI(params)

      dispatch(setList(res.data.data))
      dispatch(setPagination(res.data.pagination))
      dispatch(setIsLoadingList(false))

      return true
    } catch (error) {
      callErrorMsg(error)
      dispatch(setIsLoadingList(false))
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
